import { Constructor } from '@angular/cdk/table';
import { takeUntil } from 'rxjs/operators';
import { IAllowableState } from 'src/app/core/dtos/interfaces/i-allowable-state';
import { compareArrays } from '../utils/array-utils';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';

type WithNextStateFormSectionType = {
  _initNextStates(nextStates: IAllowableState[]): void;
  _initNextStatesValueChanges(
    getPreviousSelectedValue: () => IAllowableState[] | null,
  ): void;
  _buildNextStates(): IAllowableState[];
  get nextStates(): IAllowableState[];
};

type NextStateFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { NEXT_STATES: () => string };
  destroy$: Subject<boolean>;
};

export function WithNextStateFormSection<
  TBase extends Constructor<NextStateFormSectionRequerimentsBase>,
>(
  baseClass: TBase,
): {
  new (...args: any[]): WithNextStateFormSectionType;
  prototype: WithNextStateFormSectionType;
} & TBase {
  return class WithNextStateFormSectionable extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initNextStates(nextStates: IAllowableState[]): void {
      this.form.get(this.FORM_PATHS.NEXT_STATES()).setValue(nextStates);
    }

    _initNextStatesValueChanges(
      getPreviousSelectedValue: () => IAllowableState[] | null,
    ): void {
      this.form
        .get(this.FORM_PATHS.NEXT_STATES())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (compareArrays(newValue, getPreviousSelectedValue())) {
              this.form.get(this.FORM_PATHS.NEXT_STATES()).markAsPristine();
            }
          },
        });
    }

    _buildNextStates(): IAllowableState[] {
      return this.form.get(this.FORM_PATHS.NEXT_STATES()).value;
    }

    get nextStates(): IAllowableState[] {
      return this.form.get(this.FORM_PATHS.NEXT_STATES()).value;
    }
  };
}
